(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["section-accessories-list"]) return;
  try {
    

jQuery(document).on('click', '.section-accessories-list > .section-collapsed > .section-collapsed-row > .section-collapsed-row-title', function(e) {
    e.stopPropagation();
    e.preventDefault(); 
    if (!$(this).parents('.section-collapsed .section-collapsed-row').hasClass('open')) {
        $('.section-collapsed .section-collapsed-row').removeClass('open');
      	$(this).parents('.section-collapsed .section-collapsed-row').addClass('open');
    } else {
        $('.section-collapsed .section-collapsed-row').removeClass('open');
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq-only"]) return;
  try {
    

jQuery(document).on('click', '.section-faq-only .section-collapsed-row-title', function(e) {
  if( !$(this).closest('.section-collapsed-row').hasClass('open') ) {
  	$('.section-collapsed-row.open').removeClass('open');
  }
  $(this).closest('.section-collapsed-row').toggleClass('open');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq"]) return;
  try {
    

jQuery(document).on('click', '.section-faq > .section-collapsed > .section-collapsed-row > .section-collapsed-row-title', function(e) {
    e.stopPropagation();
    e.preventDefault();
    if (!$(this).parents('.section-collapsed .section-collapsed-row').hasClass('open')) {
        $('.section-collapsed .section-collapsed-row').removeClass('open');
      	$(this).parents('.section-collapsed .section-collapsed-row').addClass('open');
    } else {
        $('.section-collapsed .section-collapsed-row').removeClass('open');
    }
});

jQuery(document).on('click', '.section-faq .section-collapsed .section-collapsed-row.faq .section-collapsed-row  .section-collapsed-row-title', function(e) {
    e.stopPropagation();
    e.preventDefault();
    if (!$(this).closest('.section-collapsed-row').hasClass('open')) {
        $(this).closest('.section-collapsed-row.faq').find('.section-collapsed-row').removeClass('open');
      	$(this).closest('.section-collapsed-row').addClass('open');
    } else {
        $('.section-collapsed-row.faq .section-collapsed-row-data .section-collapsed-row').removeClass('open');
    }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-header-adhesives"]) return;
  try {
    
$(document).on('click', ".stamped-product-reviews-badge", function(e) {
  	e.preventDefault();
  	e.stopPropagation();

    $(document).scrollTop( $("#shopify-section-section-reviews .section-title").offset().top - 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-header-go2"]) return;
  try {
    
$(document).on('click', ".stamped-product-reviews-badge", function(e) {
  	e.preventDefault();
  	e.stopPropagation();

    $(document).scrollTop( $("#shopify-section-section-reviews .section-title").offset().top - 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-header-necklace"]) return;
  try {
    
$(document).on('click', ".stamped-product-reviews-badge", function(e) {
  	e.preventDefault();
  	e.stopPropagation();

    $(document).scrollTop( $("#shopify-section-section-reviews .section-title").offset().top - 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-header"]) return;
  try {
    
$(document).on('click', ".stamped-product-reviews-badge", function(e) {
  	e.preventDefault();
  	e.stopPropagation();

    $(document).scrollTop( $("#shopify-section-section-reviews .section-title").offset().top - 100);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-necklace-slide"]) return;
  try {
    
$('.section-necklace-slide .section-necklace-nav a').on('click', function(){
	var eq = $('.section-necklace-slide .section-necklace-nav a.active').index();
	var currenq_eq = $(this).index();
	$('.section-necklace-slide .section-necklace-nav a').removeClass('active');
	$(this).addClass('active');
	$('.section-necklace-slide .section-inner .section-row').removeClass('hide');
	$('.section-necklace-slide .section-inner .section-row').eq(eq).addClass('hide');

	$('.section-necklace-slide .section-necklace-nav .section-necklace-nav-dots li').removeClass('active');
	$('.section-necklace-slide .section-necklace-nav .section-necklace-nav-dots li').eq(currenq_eq).addClass('active')
})
$('.section-necklace-slide .section-necklace-nav .section-necklace-nav-dots li').on('click', function(){
	var eq = $('.section-necklace-slide .section-necklace-nav .section-necklace-nav-dots li.active').index();
	var currenq_eq = $(this).index();
	$('.section-necklace-slide .section-necklace-nav a').removeClass('active');
	$('.section-necklace-slide .section-necklace-nav a').eq(currenq_eq).addClass('active');
	$('.section-necklace-slide .section-inner .section-row').removeClass('hide');
	$('.section-necklace-slide .section-inner .section-row').eq(eq).addClass('hide');

	$('.section-necklace-slide .section-necklace-nav .section-necklace-nav-dots li').removeClass('active');
	$('.section-necklace-slide .section-necklace-nav .section-necklace-nav-dots li').eq(currenq_eq).addClass('active')
})
$(document).on('swiped-right swiped-left', '.section-necklace-slide .section-inner', function(){
	var eq = $('.section-necklace-slide .section-necklace-nav .section-necklace-nav-dots li.active').index();

	$('.section-necklace-slide .section-necklace-nav a').removeClass('active');
	$('.section-necklace-slide .section-necklace-nav a').not(':eq(' + eq + ')').addClass('active');
	$('.section-necklace-slide .section-inner .section-row').removeClass('hide');
	$('.section-necklace-slide .section-inner .section-row').eq(eq).addClass('hide');

	$('.section-necklace-slide .section-necklace-nav .section-necklace-nav-dots li').removeClass('active');
	$('.section-necklace-slide .section-necklace-nav .section-necklace-nav-dots li').not(':eq(' + eq + ')').addClass('active')
})

  } catch(e) { console.error(e); }
})();

})();
